import { Body } from "@sprout/typography";
import type { PayRange } from "@/types/jben/job_post.ts";
import { RichText, sanitizeRichText } from "./rich_text";
import "./application_description.scss";

interface Props {
  introduction: string;
  content: string;
  conclusion: string;
  payRanges?: PayRange[];
}

export const ApplicationDescription = ({ introduction, content, conclusion, payRanges }: Props) => {
  const showPayRanges = payRanges && payRanges.length > 0;

  const renderPayRanges = () =>
    payRanges?.map((payRange) => (
      <div className="pay-range" key={payRange.title}>
        {payRange.description && (
          <div className="description">
            <Body as="div">
              <span dangerouslySetInnerHTML={{ __html: sanitizeRichText(payRange.description) }} />
            </Body>
          </div>
        )}
        <Body medium>{payRange.title}</Body>
        <Body>
          <bdi>{payRange.min}</bdi> - <bdi>{payRange.max}</bdi> <bdi>{payRange.currency_type}</bdi>
        </Body>
      </div>
    ));

  return (
    <div className="application-description body">
      {introduction && <RichText html={introduction} />}
      {content && <RichText html={content} />}
      {showPayRanges && (
        <div className="application-description--pay-ranges">{renderPayRanges()}</div>
      )}
      {conclusion && <RichText html={conclusion} />}
      <hr className="application-description--divider" />
    </div>
  );
};
